import React from 'react'
import { Button, Header, Icon, Table } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import PermissionsManager from '../components/PermissionsManager'
import Unauthorized from '../components/Unauthorized'
import { PERMISSIONS } from '../constants'

const UsersLayout = props => {
  const permissions = localStorage.getItem(PERMISSIONS)
  if (permissions.indexOf('get_users') === -1) {
    return (
      <Unauthorized></Unauthorized>
    )
  }

  if (!props.users || props.users.length === 0) {
    return (
      <div>
        Aucun enregistrement
        <PermissionsManager hasPermissions={['create_user']}>
          <Button as={Link} floated="right" icon labelPosition="left" color="olive" size="small" to="/users/new">
            <Icon name="user" /> Ajouter un utilisateur
          </Button>
        </PermissionsManager>
      </div>
    )
  }
  return (
    <div>
      <Header as="h1">Utilisateurs</Header>
      <Table celled selectable singleLine color="red">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Nom</Table.HeaderCell>
            <Table.HeaderCell>Email</Table.HeaderCell>
            <Table.HeaderCell>Dernière modification</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {props.users.map(user => {
            return (
              <Table.Row key={user.id}>
                <Table.Cell>
                  <Link as="a" name="user" to={`users/${user.id}`}>
                    {user.firstName} {user.lastName}
                  </Link>
                </Table.Cell>
                <Table.Cell>
                  <Link as="a" name="user" to={`users/${user.id}`}>
                    {user.email}
                  </Link>
                </Table.Cell>
                <Table.Cell>{user.created_at}</Table.Cell>
              </Table.Row>
            )
          })}
        </Table.Body>

        <PermissionsManager hasPermissions={['create_user']}>
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan="4">
                <Button as={Link} floated="right" icon labelPosition="left" color="olive" size="small" to="/users/new">
                  <Icon name="user" /> Ajouter un utilisateur
                </Button>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </PermissionsManager>
      </Table>
    </div>
  )
}

export default UsersLayout



// WEBPACK FOOTER //
// ./src/layout/UsersLayout.js